import clsx from 'clsx';
import { FC } from 'react';
import { IconSVG } from 'atoms/IconSVG';
import { gtmPushShopNavigation } from 'modules/gtm/modules/sections/navigation/navigation';
import { useTranslations } from 'modules/i18n/useTranslations';
import { usePopoverManager } from 'modules/shop/popoverManager/hooks';
import { PopoverType } from 'modules/shop/popoverManager/types';
import styles from './LoginIcon.module.css';

export const LoginIcon: FC<{
  className?: string;
  color?: 'black' | 'white';
  imgClassName?: string;
  onClick?: () => void;
}> = ({ className, color = 'black', imgClassName, onClick }) => {
  const t = useTranslations();
  const gtmAccountEventLabel = t('header.gtmNavigationLabels.accountIcon');

  const { openPopover } = usePopoverManager();

  const handleWishlistIconClick = () => {
    onClick?.();
    openPopover(PopoverType.LOGIN);
    gtmPushShopNavigation(gtmAccountEventLabel);
  };

  return (
    <div
      className={clsx(styles.icon, className)}
      onClick={handleWishlistIconClick}
    >
      <IconSVG
        type="login"
        onClick={onClick}
        className={clsx(styles.invertIcon, imgClassName, styles[color])}
      />
    </div>
  );
};
